import { render, staticRenderFns } from "./transactionNew.vue?vue&type=template&id=15b81372&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./transactionNew.vue?vue&type=script&lang=js&"
export * from "./transactionNew.vue?vue&type=script&lang=js&"
import style0 from "./transactionNew.vue?vue&type=style&index=0&id=15b81372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b81372",
  null
  
)

export default component.exports